import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setupLeftNavLabel: {
    defaultMessage: 'Setup',
    id: 'DasFfC',
    description: 'Label for setup tab',
  },
  dashboardLeftNavLabel: {
    defaultMessage: 'Dashboard',
    id: 'nRQZ6/',
    description: 'Label For Dashboard Left Nav Items',
  },
  asnLeftNavLabel: {
    defaultMessage: 'Advance Shipping Notices',
    id: 'Yi2QpC',
    description: 'Label For Advance Shipping Notices Left Nav Items',
  },
  returnsLeftNavLabel: {
    defaultMessage: 'Returns',
    id: 'botDk7',
    description: 'Label For Returns Left Nav Items',
  },
  resourcesLeftNavLabel: {
    defaultMessage: 'Resources',
    id: 'mtva3n',
    description: 'Label for resources tab',
  },
  searchLabel: {
    defaultMessage: 'Fulfillments Quicksearch',
    description: 'Label for Fulfillments page quicksearch input',
    id: 'Lt/2DD',
  },
  searchPlaceholder: {
    defaultMessage: 'Search Fulfillments...',
    description: 'placeholder text for fulfillments search input',
    id: '0THDgB',
  },
});
